import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';

const coursesData = [
  {
    name: 'Beginners Certificate',
    duration: '1 Week',
    price: '₹45,000',
    description: 'Perfect for those new to jewellery making. Learn the fundamentals and create your first handcrafted pieces.',
    content: [
      'Introduction to metals (types, rates, density)',
      'Metal composition and properties',
      'Introduction to essential tools',
      'Basic tool making',
      'Simple ring crafting techniques',
      'Welding fundamentals',
    ],
    featured: false,
  },
  {
    name: 'Intermediate Certificate',
    duration: '2 Weeks',
    price: '₹80,000',
    description: 'Build on your foundation with advanced techniques and expand your repertoire of jewellery pieces.',
    content: [
      'All Beginners Certificate content',
      'Stone setting techniques',
      'Bangle making and design',
      'Advanced welding methods',
      'Quality control and finishing',
      'Design principles',
    ],
    featured: false,
  },
  {
    name: 'Expert Certificate',
    duration: '1 Month',
    price: '₹1,50,000',
    description: 'Master the craft with comprehensive training in complex jewellery making and diamond setting.',
    content: [
      'All Intermediate Certificate content',
      'Necklace making and design',
      'Diamond setting techniques',
      'Complex jewellery structures',
      'Professional finishing methods',
      'Advanced design and creativity',
    ],
    featured: true,
  },
];

export const populateCourses = async () => {
  try {
    // Check if courses already exist
    const coursesRef = collection(db, 'courses');
    const snapshot = await getDocs(coursesRef);
    
    if (snapshot.empty) {
      // Add all courses
      const promises = coursesData.map(course => addDoc(coursesRef, course));
      await Promise.all(promises);
      console.log('Courses populated successfully!');
      return true;
    } else {
      console.log('Courses already exist in database');
      return false;
    }
  } catch (error) {
    console.error('Error populating courses:', error);
    throw error;
  }
};
